import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=fef53c56"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports